import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-center"
      duration={3000}
      closeButton={true}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pr-8",
          description:
            // Sonner injects its own styles at runtime with high specificity
            // ([data-sonner-toast] [data-description]) and applies opacity:0.5
            // on the description - without `!important` both the color and
            // the opacity get overridden and the text stays nearly invisible.
            "group-[.toast]:!text-foreground/80 group-[.toast]:!opacity-100",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "!right-2 !left-auto !top-1/2 !-translate-y-1/2 !border-0 !outline-none !ring-0 group-[.toast]:bg-background group-[.toast]:text-foreground group-[.toast]:hover:bg-muted",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
